module.exports = __webpack_public_path__ + "img/video.6758dae8.svg";